// extracted by mini-css-extract-plugin
export default {"renew-switcher":"renew-switcher___KXkmO","title":"title___nhhdb","description":"description___jbqQd"};